import {
  createRootRoute,
  createRoute,
  createRouter,
  parseSearchWith,
  stringifySearchWith,
} from "@tanstack/react-router";
import type { View } from "@/model/overview";
import { AllEvents } from "@/pages/AllEvents";
import { History } from "@/pages/History";
import { Overview } from "@/pages/Overview";
import { People } from "@/pages/people/People";
import { Send } from "@/pages/Send";
import { Settings } from "@/pages/Settings";
import { Shell } from "@/shell/Shell";

const rootRoute = createRootRoute({ component: Shell });

export interface PeopleSearch {
  v?: View;
  s?: string;
  p?: string;
}

const str = (x: unknown) => (typeof x === "string" && x ? x : typeof x === "number" ? String(x) : undefined);

const routeTree = rootRoute.addChildren([
  createRoute({ getParentRoute: () => rootRoute, path: "/", component: AllEvents }),
  createRoute({ getParentRoute: () => rootRoute, path: "/wa", component: Overview }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/people",
    component: People,
    validateSearch: (s: Record<string, unknown>): PeopleSearch => {
      const v = s.v === "attention" || s.v === "replied" ? s.v : undefined;
      return { v, s: str(s.s), p: str(s.p) };
    },
  }),
  createRoute({ getParentRoute: () => rootRoute, path: "/send", component: Send }),
  createRoute({ getParentRoute: () => rootRoute, path: "/history", component: History }),
  createRoute({ getParentRoute: () => rootRoute, path: "/settings", component: Settings }),
]);

// Plain string params (?p=919812345678), not JSON-encoded ones (?p=%22919…%22): deep links stay readable.
export const router = createRouter({
  routeTree,
  defaultPreload: false,
  scrollRestoration: false,
  parseSearch: parseSearchWith((v) => v),
  stringifySearch: stringifySearchWith((v) => String(v)),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
